import _ from 'lodash';
import React from 'react';

// Components
import { CHECKOUT_KEY } from '../../partner/utils';
import ConfirmationStep from '../components/partner/ConfirmationStep/ConfirmationStep';
import InsuranceStep from '../components/partner/InsuranceStep/InsuranceStep';
import PatientStep from '../components/partner/PatientStep/PatientStep';
import RedirectionStep from '../components/partner/RedirectionStep/RedirectionStep';

// Other

export const PARTNER_CHECKOUT_STEPS = [
  {
    name: 'patient',
    progressTitle: 'Account',
    alternateProgressTitle() {
      return null;
    },
    modalWidth() {
      return '420px';
    },
    bookingStep: false,
    state(_data, storage) {
      const storedPatient = storage.get(CHECKOUT_KEY.PATIENT);
      return {
        isLoading: storage.loading,
        isCleared: storage.isEmpty(),
        id: _.get(storedPatient, 'id'),
        email: _.get(storedPatient, 'email'),
        mobilePhone: _.get(storedPatient, 'mobilePhone', '').replace('+1', ''),
        partnerInternalId: storedPatient?.metadata?.partnerInternalId,
      };
    },
    isHidden() {
      // this should always be false
      return false;
    },
    hideFromProgressBar() {
      return false;
    },
    validate() {
      return true;
    },
    render(handleNextStep, state) {
      return <PatientStep handleNextStep={handleNextStep} state={state} />;
    },
  },
  {
    name: 'insurance',
    progressTitle: 'Insurance',
    alternateProgressTitle(data) {
      if (_.get(data.match, 'other.hasInsurance') === 'No') {
        return 'Patient';
      }
      return null;
    },
    modalWidth(data) {
      if (_.get(data.match, 'other.hasInsurance') === 'No') {
        return '420px';
      }
      return '800px';
    },
    bookingStep: false,
    state(_data, storage) {
      const storedPatient = storage.get(CHECKOUT_KEY.PATIENT);
      const storedInsuranceDetails = storage.get(CHECKOUT_KEY.INSURANCE);

      return {
        isLoading: storage.loading,
        isCleared: storage.isEmpty(),
        id: _.get(storedPatient, 'id'),
        email: _.get(storedPatient, 'email'),
        metadata: _.get(storedPatient, 'metadata'),
        firstName: _.get(storedInsuranceDetails, 'firstName'),
        lastName: _.get(storedInsuranceDetails, 'lastName'),
        dateOfBirth: [
          _.get(storedInsuranceDetails, 'birthYear'),
          _.get(storedInsuranceDetails, 'birthMonth'),
          _.get(storedInsuranceDetails, 'birthDay'),
        ],
        memberId: _.get(storedInsuranceDetails, 'memberId'),
        employer: _.get(storedInsuranceDetails, 'employer'),
        groupNumber: _.get(storedInsuranceDetails, 'groupNumber'),
        isPrimaryMember: _.get(storedInsuranceDetails, 'isPrimaryMember'),
        memberfirstName: _.get(storedInsuranceDetails, 'memberfirstName'),
        memberlastName: _.get(storedInsuranceDetails, 'memberlastName'),
        memberdateOfBirth: [
          _.get(storedInsuranceDetails, 'memberbirthYear'),
          _.get(storedInsuranceDetails, 'memberbirthMonth'),
          _.get(storedInsuranceDetails, 'memberbirthDay'),
        ],
      };
    },
    isHidden() {
      return false;
    },
    hideFromProgressBar() {
      return false;
    },
    validate() {
      return true;
    },
    render(handleNextStep, state) {
      return <InsuranceStep handleNextStep={handleNextStep} state={state} />;
    },
  },
  {
    name: 'confirm',
    progressTitle: 'Confirm',
    alternateProgressTitle() {
      return null;
    },
    modalWidth() {
      return '420px';
    },
    bookingStep: true,
    state(_data, storage) {
      const storedPatient = storage.get(CHECKOUT_KEY.PATIENT);
      const storedInsuranceDetails = storage.get(CHECKOUT_KEY.INSURANCE);

      return {
        isLoading: storage.loading,
        isCleared: storage.isEmpty(),
        id: _.get(storedPatient, 'id'),
        email: _.get(storedPatient, 'email'),
        mobilePhone: _.get(storedPatient, 'mobilePhone'),
        partnerInternalId: storedPatient?.metadata?.partnerInternalId,
        firstName:
          _.get(storedPatient, 'firstName')
          || _.get(storedInsuranceDetails, 'firstName'),
        lastName:
          _.get(storedPatient, 'lastName')
          || _.get(storedInsuranceDetails, 'lastName'),
        insuranceDetails: storedInsuranceDetails,
      };
    },
    isHidden() {
      // this should always be false
      return false;
    },
    hideFromProgressBar() {
      return false;
    },
    validate() {
      return true;
    },
    render(handleNextStep, state, close) {
      return (
        <ConfirmationStep
          handleNextStep={handleNextStep}
          state={state}
          close={close}
        />
      );
    },
  },
  {
    name: 'complete',
    progressTitle: 'Complete',
    alternateProgressTitle() {
      return null;
    },
    modalWidth() {
      return '420px';
    },
    bookingStep: false,
    state(_data, storage) {
      const storedPatient = storage.get(CHECKOUT_KEY.PATIENT);

      return {
        isLoading: storage.loading,
        id: _.get(storedPatient, 'id'),
      };
    },
    isHidden() {
      // this should always be false
      return false;
    },
    hideFromProgressBar() {
      return true;
    },
    validate() {
      return true;
    },
    render(handleNextStep, state, close) {
      return (
        <RedirectionStep
          handleNextStep={handleNextStep}
          state={state}
          close={close}
        />
      );
    },
  },
];
